import React from "react";
import styled from "styled-components";

/**
 * fully visible header
 */
const StyledHeader = styled.header`
  width: 100%;
  color: #ffffff;
  background: ${(props) => props.theme.color.blue};
  padding: 1.9em 1.5em;
  display: flex;
  justify-content: space-between;
  /* z-index: 2; */
`;

/**
 * header is only visible to screen readers
 */
const HiddenHeader = styled(StyledHeader)`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const LogoHeader = styled.h1`
  line-height: 0;
  margin: 0;
`;

const LogoImage = styled.img`
  width: 108px;
`;

const LockIcon = styled.img`
  width: 13px;
  height: 18px;
  display: inline-block;
  margin-right: 0.4em;
  margin-bottom: 0.25em;
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

/**
 * if hideHeader is passed in, return header that can only be seen by screen
 * readers otherwise return normal header type
 */
const HeaderType = ({ hideHeader, children, ...rest }) => {
  if (hideHeader) {
    return <HiddenHeader {...rest}>{children}</HiddenHeader>;
  } else {
    return <StyledHeader {...rest}>{children}</StyledHeader>;
  }
};

export default function Header({ ...rest }) {
  return (
    <HeaderType {...rest}>
      <LogoHeader>
        <LogoImage
          src={process.env.PUBLIC_URL + "/static/images/siebert-logo.svg"}
          alt="Siebert"
        />
      </LogoHeader>
      <StyledDiv>
        <LockIcon
          src={process.env.PUBLIC_URL + "/static/images/iconSecure.svg"}
          alt=""
        />
        Secured
      </StyledDiv>
    </HeaderType>
  );
}
